<!--核房人-支付人-入住名单--->
<template>
  <div class="checkList mt-4">
    <!--核房人-->
    <div class="nuclearRoom">
      <div class="nuclearRoom-title">
        核房人
        <div class="remark">
          <span>(对核房人酒店价格保密 )</span>
          <el-button class="addBtn" type="primary" plain icon="el-icon-plus" size="mini">添加</el-button>
        </div>
      </div>
    </div>
    <!--支付人-->
    <div class="nuclearRoom">
      <div class="nuclearRoom-title">
        支付人
        <div class="remark">
          <span>(仅允许添加一位支付人 )</span>
          <el-button class="addBtn" type="primary" plain icon="el-icon-plus" size="mini">添加</el-button>
        </div>
      </div>
    </div>
    <!--入住名单-->
    <div class="nuclearRoom">
      <div class="nuclearRoom-title">
        入住名单
        <div class="remark">
          <span>(可上传 doc、xls、jpg、png 格式)</span>
          <el-button class="addBtn" type="primary" plain icon="el-icon-plus" size="mini">上传</el-button>
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
export default {
  name: 'OrderCheckList',
  components: {},
  props: {},
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
  .checkList{
    .nuclearRoom{
      width: 100%;
      border-radius: 5px;
      padding: 10px 1%;
      font-size: 14px;
      color: #333;
       background-color: #fff;
    }
    .nuclearRoom:nth-child(1){
      margin-left: 0;
    }
    .nuclearRoom-title{
      line-height: 30px;
      font-weight: bold;
    }
  }
  .remark{
    float: right;
    display: flex;
    align-items: center;
    span{
      font-size: 12px;
      font-weight: normal;
      margin-right: 10px;
      color: #999;
    }
  }
</style>
